// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".drawer-button[data-v-3866531e]{position:fixed;top:44px;left:-22px;z-index:6}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
